
import { Calendar, CheckCircle, LucideIcon } from "lucide-react";
import { openGoogleCalendar } from "@/lib/utils";

interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  features: string[];
  buttonText?: string;
  buttonUrl?: string;
  highlighted?: boolean;
  onSchedule: () => void;
}

export function ServiceCard({
  icon: Icon,
  title,
  description,
  features,
  buttonText,
  buttonUrl,
  highlighted,
  onSchedule,
}: ServiceCardProps) {
  const btnClass =
    "w-full flex items-center justify-center gap-2 bg-brand-primary hover:bg-brand-primary/90 text-white font-primary font-semibold text-sm rounded-xl px-4 py-2.5 transition-colors shadow-sm";

  return (
    <div className="relative bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col overflow-hidden">
      {/* Destaque badge */}
      {highlighted && (
        <div className="absolute top-3 right-3 z-10 bg-yellow-400 text-yellow-900 text-[10px] font-bold px-2 py-0.5 rounded-full leading-none">
          ⭐ Destaque
        </div>
      )}

      {/* cabeçalho verde */}
      <div className="bg-brand-primary px-6 py-5 flex items-center gap-4">
        <div className="w-11 h-11 bg-white/15 rounded-xl flex items-center justify-center shrink-0">
          <Icon className="w-5 h-5 text-white" />
        </div>
        <h3 className="text-base font-bold text-white font-primary leading-snug">{title}</h3>
      </div>

      {/* corpo */}
      <div className="flex-1 flex flex-col px-6 py-5 gap-4">
        {description && (
          <p className="text-sm text-gray-500 leading-relaxed">{description}</p>
        )}

        {features.length > 0 && (
          <ul className="space-y-2">
            {features.map((feature, i) => (
              <li key={i} className="flex items-center gap-2.5 text-sm text-gray-600">
                <CheckCircle className="w-4 h-4 text-brand-primary shrink-0" />
                {feature}
              </li>
            ))}
          </ul>
        )}

        <div className="mt-auto pt-2">
          {buttonUrl ? (
            <a href={buttonUrl} target="_blank" rel="noopener noreferrer" className={btnClass}>
              <Calendar className="w-4 h-4" />
              {buttonText || "Agendar Consulta"}
            </a>
          ) : (
            <button onClick={onSchedule} className={btnClass}>
              <Calendar className="w-4 h-4" />
              {buttonText || "Agendar Consulta"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
